import script from "./productdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./productdetail.vue?vue&type=script&setup=true&lang=js"

import "./productdetail.vue?vue&type=style&index=0&id=ce2f0bb0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce2f0bb0"]])

export default __exports__